import { HttpClient, HttpErrorResponse, HttpEventType } from '@angular/common/http';
import { Injectable, HostListener, Inject, OnInit } from '@angular/core';
import { BehaviorSubject, Observable, Subscriber, throwError } from 'rxjs';
import { WINDOW } from "./windows.service";
import { environment } from 'src/environments/environment';
import { ProductsDTO,ImageDTO, Image1DTO } from '../models/model';
import { NotificationService } from './notification.service';
import { LocalDataSource } from 'ng2-smart-table';
import { catchError } from 'rxjs/operators';

@Injectable()
export class productService implements OnInit {
    public Products: ProductsDTO[];
    public Source: LocalDataSource;

    constructor(private http: HttpClient, private notifcationService: NotificationService) {
        this.Source = new LocalDataSource();
        //this.Products=new Array<ProductDTO>();
    }

    addProduct(Product: ProductsDTO) {

        return this.http.post(environment.apiUrl + "/Product", Product).subscribe(
            data => {
                this.notifcationService.showSuccess("Product", "ajout avec success");
            },
            (error) => {
                this.notifcationService.showError("Product", "ajout avec success");
                console.error(error);
            }
        );
    }

    updateProduct(Product: ProductsDTO) {

        return this.http.put(environment.apiUrl + "/Product", Product).subscribe(
            data => {
                this.notifcationService.showSuccess("Product", "ajout avec success");
            },
            (error) => {
                this.notifcationService.showError("Product", "ajout avec success");
                console.error(error);
            }
        );

    }


    getProducts(source: boolean): any {
        if (source) {
            this.http.get<ProductsDTO[]>(environment.apiUrl + "/Product").pipe(
                catchError(this.handleError)

            );
        } else {
            this.http.get<ProductsDTO[]>(environment.apiUrl + "/Product").pipe(
                catchError(this.handleError)

            );
        }

    }

    getAllProducts(): any {
        return this.http.get<ProductsDTO[]>(environment.apiUrl + "/Product")
            .pipe(
                catchError(this.handleError)
            );
    }

    getImage(idProduct:number,Idvariant:number):any{
        return this.http.get<ImageDTO>(environment.apiUrl + "/Product/"+idProduct+"/"+Idvariant)
            .pipe(
                catchError(this.handleError)
            );
    }




    deleteProduct(CodeProduct: string) {
        this.http.delete<any>(environment.apiUrl + "/Product/" + CodeProduct).subscribe(
            data => {
                this.notifcationService.showSuccess("Product", "suppression avec success");
            },
            (error) => {
                this.notifcationService.showError("Product", "suppression avec success");
                console.error(error);
            }
        );
    }

    uploadImages(formData: FormData) {
        debugger
        console.log(formData);
        this.http.post(environment.apiUrl+"/Product/Upload/", formData, { reportProgress: true, observe: 'events' })
            .subscribe(
                data => {
                    this.notifcationService.showSuccess("Product", "upload avec success");
                },
                (error) => {
                    this.notifcationService.showError("Product", "upload avec success");
                    console.error(error.message);
                }
            );
    }

    addImages(imageDTO:Image1DTO,event:any){
        event.preventDefault();
        return this.http.post(environment.apiUrl+"/Product/ProductImg", imageDTO).pipe()
            .subscribe(
                data => {
                    this.notifcationService.showSuccess("Product", "image upload avec success");
        window.stop(); 

                },
                (error) => {
                    this.notifcationService.showError("Product", "image upload failure");
                    console.error(error.message);
                }
            );
    }

    

    ngOnInit(): void {
        throw new Error('Method not implemented.');
    }

    private handleError(error: HttpErrorResponse) {
        if (error.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            console.error('An error occurred:', error.error.message);
        } else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            console.error(
                `Backend returned code ${error.status}, ` +
                `body was: ${error.error}`);
        }
        // return an observable with a user-facing error message
        return throwError(error.error);
    };



}

